import HeaderMenuItems from 'Components/Header/HeaderMenuItems';
import SidePanelMobile, { SidePanelItem, MobileSectionBar } from 'Components/Professional/Cases/SidePanelMobile';
import { adminAnalyticsPanelItems } from 'Constants';
import useIsMobile from 'Hooks/useIsMobile';
import { Menu } from 'lucide-react';
import React, { useState } from 'react'

function AdminSidePanel({ setActivePanel, activePanel }) {
    const isMobile = useIsMobile();
    const [openMenu, setOpenMenu] = useState(false);
  return (
    <div className=''>
      {isMobile &&
        <SidePanelMobile
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          eyebrow='Admin'
          title='Analytics'
          content={adminAnalyticsPanelItems.map((item) => (
            <SidePanelItem key={item.key} active={activePanel === item.key}
              onClick={() => { setActivePanel(item.key); setOpenMenu(false); }}>
              {item.menu}
            </SidePanelItem>
          ))}
        />}
      {/* phones only - desktop keeps its left panel */}
      <div className='lg:hidden'>
        <MobileSectionBar
          eyebrow='Analytics'
          title={adminAnalyticsPanelItems.find((item) => item.key === activePanel)?.menu || 'Analytics'}
          onMenu={() => setOpenMenu(true)}
        />
      </div>
    </div>
  )
}

export default AdminSidePanel
